/*
 * @Author: edvardchen
 * @Date: 2017-07-31 16:40:34
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-11-22 17:08:15
 */
// @flow
// import _ from 'lodash';
import { actionTypes } from '../actions/installer';

export const installStatus = {
  DEFAULT: 0,
  LOADING: 1,
  LOADED: 2,
  INSTALLED: 3,
};

export default (state: Object = {}, { type, ...restAction }: { type: number | string }) => {
  const nextState = {
    installed: false,
    installStatus: 0,
    ...state,
  };
  switch (type) {
    case actionTypes.UPDATE_STATUS: {
      const { status, percent = 0 } = restAction;
      return {
        ...nextState,
        installStatus: status,
        donwloadPercent: percent,
        installed: status === installStatus.INSTALLED,
      };
    }
    case actionTypes.SHOW_MASK:
      return {
        ...nextState,
        installMask: {
          ...restAction,
          show: true,
        },
      };
    case actionTypes.HIDE_MASK:
      return {
        ...nextState,
        installMask: {
          show: false,
        },
      };
    case actionTypes.SHOW_DB_BAR:
      return {
        ...nextState,
        DBBarShown: true,
      };
    case actionTypes.HIDE_DB_BAR:
      return {
        ...nextState,
        DBBarShown: false,
      };
    case actionTypes.REMOVE_DB_BAR:
      return {
        ...nextState,
        DBBarRemoved: true,
      };
    case actionTypes.SHARELP_MODAL:
      return {
        ...nextState,
        showModal: restAction.show || false,
      };
    default:
      return nextState;
  }
};
